export declare type TableAttributeType = 'string' | 'number' | 'boolean' | 'string[]';

interface ConstructorParams {
    name: string;
    label: string;
    type: TableAttributeType;
    longText?: boolean;
    capitalise?: boolean,
    required: boolean;
    primaryKey: boolean;
    linkedTable?: string;
    linkedField?: string;
    showCopy?: boolean;
    fieldType?: string;
    /** Server fills this in on create (e.g. auto-increment); hidden in the create form. */
    autoGenerated?: boolean;
}

export default class TableAttributeModel {
    name: string;
    label: string;
    type: TableAttributeType;
    longText: boolean;
    capitalise: boolean;
    required: boolean;
    primary: boolean;
    linkedTable?: string;
    linkedAttributeName?: string;
    showCopy: boolean;
    fieldType?: string;
    autoGenerated: boolean;

    constructor({
                    name,
                    label,
                    type,
                    longText = false,
                    capitalise = false,
                    required,
                    primaryKey,
                    linkedTable,
                    linkedField,
                    showCopy,
                    fieldType,
                    autoGenerated
                }: ConstructorParams) {
        this.name = name;
        this.label = label;
        this.type = type;
        this.longText = longText;
        this.capitalise = capitalise;
        this.required = required;
        this.primary = primaryKey;
        this.linkedTable = linkedTable;
        this.linkedAttributeName = linkedField;
        this.showCopy = showCopy ?? false;
        this.fieldType = fieldType;
        this.autoGenerated = autoGenerated ?? false;
    }
}
